const SITE_URL = 'https://www.swiglobal.com'
const ORG_ID = `${SITE_URL}/#organization`

const ORGANIZATION_SCHEMA = {
  '@type': ['Organization', 'InsuranceAgency'],
  '@id': ORG_ID,
  name: '上海耀达保险代理有限公司',
  alternateName: ['SWI', '耀达保险', 'Sun Wisdom Insurance'],
  url: SITE_URL,
  foundingDate: '2009',
  description: '专业保险经纪机构，提供董责险、并购W&I、网络安全险、财产险、员工福利及个人高端医疗等一站式保险解决方案。',
  address: [
    {
      '@type': 'PostalAddress',
      addressLocality: '上海',
      addressCountry: 'CN',
      streetAddress: '上海市长宁区娄山关路523号金虹桥国际中心1座1206室'
    },
    {
      '@type': 'PostalAddress',
      addressLocality: '香港',
      addressCountry: 'HK',
      streetAddress: '香港金钟道89号力宝中心二座16楼12室'
    }
  ],
  areaServed: ['CN', 'HK', 'US', 'SG'],
  knowsAbout: ['董责险', 'D&O Insurance', '并购保险', 'W&I保险', '网络安全险', '员工福利', '高端医疗', '保险经纪'],
  sameAs: [
    'https://www.swiglobal.com/AboutUs',
    'https://www.swiglobal.com/companyFacts'
  ]
}

function upsertMeta(name, content, attr = 'name') {
  if (!content) return
  let el = document.querySelector(`meta[${attr}="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel, href) {
  if (!href) return
  let el = document.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id)
  if (!el) {
    el = document.createElement('script')
    el.type = 'application/ld+json'
    el.id = id
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

export function buildFaqJsonLd(faqItems = []) {
  if (!faqItems.length) return null
  return {
    '@type': 'FAQPage',
    mainEntity: faqItems.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: a
      }
    }))
  }
}

export function buildPageJsonLd({ seo = {}, faqItems = [], path = '/' }) {
  const graph = [{ ...ORGANIZATION_SCHEMA }]

  const faqSchema = buildFaqJsonLd(faqItems)
  if (faqSchema) graph.push(faqSchema)

  if (seo.serviceName) {
    graph.push({
      '@type': 'Service',
      name: seo.serviceName,
      description: seo.description,
      provider: { '@id': ORG_ID },
      url: `${SITE_URL}${path}`,
      areaServed: ['CN', 'HK', 'US']
    })
  }

  graph.push({
    '@type': 'WebPage',
    name: seo.title,
    description: seo.description,
    url: `${SITE_URL}${path}`,
    isPartOf: { '@id': ORG_ID }
  })

  return {
    '@context': 'https://schema.org',
    '@graph': graph
  }
}

export function setPageSeo({ title, description, keywords, path = '/', seo = {}, faqItems = [] }) {
  if (title) document.title = title

  upsertMeta('description', description)
  upsertMeta('keywords', keywords)
  upsertMeta('og:title', title, 'property')
  upsertMeta('og:description', description, 'property')
  upsertMeta('og:url', `${SITE_URL}${path}`, 'property')
  upsertMeta('og:type', 'website', 'property')
  upsertLink('canonical', `${SITE_URL}${path}`)

  const htmlLang = document.documentElement.lang
  if (!htmlLang) {
    document.documentElement.lang = localStorage.getItem('language') === 'EN' ? 'en' : 'zh-CN'
  }

  upsertJsonLd('page-jsonld', buildPageJsonLd({ seo, faqItems, path }))
}

export { SITE_URL, ORGANIZATION_SCHEMA }
